import React from "react";

const filterExact = (filter, row) => String(row[filter.id]) === filter.value;

const optionsFilter = (filter, row) => {
  if (filter.value === "all") {
    return true;
  }
  return String(row[filter.id]) === filter.value;
};

const defaultFilterMethod = (filter, row) => {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id])
        .toLowerCase()
        .indexOf(filter.value.toLowerCase()) > -1
    : true;
};

const SelectFilter = ({ filter, onChange, name, id }) => (
  <select
    style={{ width: "100% " }}
    name={name}
    value={filter ? filter.value : "all"}
    onChange={event => onChange(event.target.value)}
    id={id}
  >
    <option value="all">All</option>
    <option value="true">Enabled</option>
    <option value="false">Disabled</option>
  </select>
);

const statusFilter = {
  filterMethod: (filter, row) => tableFilters.optionsFilter(filter, row),
  Filter: ({ filter, onChange, name, id }) =>
    tableFilters.SelectFilter({
      filter,
      onChange,
      name: "status",
      id: "status"
    })
};

export const tableFilters = {
  filterExact,
  statusFilter,
  optionsFilter,
  defaultFilterMethod,
  SelectFilter
};
